import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=a3f51df6&"
import script from "./UpdateModal.vue?vue&type=script&lang=js&"
export * from "./UpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f51df6')) {
      api.createRecord('a3f51df6', component.options)
    } else {
      api.reload('a3f51df6', component.options)
    }
    module.hot.accept("./UpdateModal.vue?vue&type=template&id=a3f51df6&", function () {
      api.rerender('a3f51df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Modals/UpdateModal.vue"
export default component.exports